"use strict";

exports.__esModule = true;
exports.PieChartBasicConfigSelector = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Core = require("../../Core");
var _helper = require("../../Widgets/MeasureChart/helper");
var _core = require("@blueprintjs/core");
var _constants = require("../constants");
var _numericInputMinMaxSanitizer = require("../../../Utils/numericInputMinMaxSanitizer");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var MIN_PAD_ANGLE = 0;
var MAX_PAD_ANGLE = 20;
var MIN_BORDER_RADIUS = 0;
var MAX_BORDER_RADIUS = 50;
var PieChartBasicConfigSelector = exports.PieChartBasicConfigSelector = function PieChartBasicConfigSelector(props) {
  var _chartItem$basicConfi, _chartItem$basicConfi2, _chartItem$basicConfi3, _chartItem$basicConfi4, _chartItem$basicConfi5;
  var _useContext = (0, _react.useContext)(_Core.TranslatorContext),
    translate = _useContext.translate;
  var elementEditor = props.elementEditor,
    path = props.path,
    itemIndex = props.itemIndex,
    chartItem = props.chartItem;
  var basicConfig = chartItem == null ? void 0 : chartItem.basicConfig;
  var defaultAggrMethod = _constants.AGGR_SUM;
  var defaultShowLabelsOutside = false;
  var defaultPadAngle = 0;
  var defaultBorderRadius = 0;
  (0, _react.useEffect)(function () {
    if (!basicConfig || Object.entries(basicConfig).length === 0) {
      elementEditor.modifyElementAt(path, function (el) {
        return {
          item: "el.props.chartItems.props[" + itemIndex + "].basicConfig",
          value: el.props.chartItems.props[itemIndex].basicConfig = {
            aggrMethod: defaultAggrMethod,
            showLabelsOutside: defaultShowLabelsOutside,
            padAngle: defaultPadAngle,
            borderRadius: defaultBorderRadius
          }
        };
      });
    }
  }, [basicConfig, elementEditor, path, itemIndex]);
  return /*#__PURE__*/_react["default"].createElement(_helper.Well, {
    "data-testid": "PieChartBasicConfigSelector"
  }, /*#__PURE__*/_react["default"].createElement(_helper.WellTitle, null, translate("PieChartBasicConfigSelector.basicConfig.label", "Basic config")), /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
    label: translate("PieChartBasicConfigSelector.basicConfig.aggrMethod.label", "Aggregation method")
  }, /*#__PURE__*/_react["default"].createElement(_Core.Selector, {
    dataTestId: "PieChartBasicConfigSelector.basicConfig.aggrMethod.selector",
    items: [_constants.AGGR_SUM, _constants.AGGR_AVG, _constants.AGGR_MAX, _constants.AGGR_MIN],
    selected: ((_chartItem$basicConfi = chartItem.basicConfig) == null ? void 0 : _chartItem$basicConfi.aggrMethod) != null ? [(_chartItem$basicConfi2 = chartItem.basicConfig) == null ? void 0 : _chartItem$basicConfi2.aggrMethod] : [defaultAggrMethod],
    getKey: function getKey(name) {
      return name;
    },
    renderItemText: function renderItemText(name) {
      return name;
    },
    onSelect: function onSelect(_ref) {
      var selected = _ref[0];
      return elementEditor.modifyElementAt(path, function (el) {
        return {
          item: "el.props.chartItems.props[" + itemIndex + "].basicConfig.aggrMethod",
          value: el.props.chartItems.props[itemIndex].basicConfig.aggrMethod = selected
        };
      });
    }
  })), /*#__PURE__*/_react["default"].createElement(_core.Switch, {
    label: translate("PieChartBasicConfigSelector.basicConfig.showLabelsOutside.label", "Show labels outside"),
    "data-testid": "PieChartBasicConfigSelector.basicConfig.showLabelsOutside.switch",
    checked: (_chartItem$basicConfi3 = chartItem.basicConfig) == null ? void 0 : _chartItem$basicConfi3.showLabelsOutside,
    onChange: function onChange(e) {
      return elementEditor.modifyElementAt(path, function (el) {
        return {
          item: "el.props.chartItems.props[" + itemIndex + "].basicConfig.showLabelsOutside",
          value: el.props.chartItems.props[itemIndex].basicConfig.showLabelsOutside = e.target.checked
        };
      });
    }
  }), /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
    label: translate("PieChartBasicConfigSelector.basicConfig.padAngle.label", "Pad angle"),
    style: {
      marginTop: "10px"
    }
  }, /*#__PURE__*/_react["default"].createElement(_core.Tooltip, {
    content: translate("PieChartBasicConfigSelector.basicConfig.padAngle.tooltip", "Angle of padding between chart items"),
    position: _core.Position.TOP
  }, /*#__PURE__*/_react["default"].createElement(_core.NumericInput, {
    "data-testid": "PieChartBasicConfigSelector.basicConfig.padAngle.input",
    min: MIN_PAD_ANGLE,
    max: MAX_PAD_ANGLE,
    style: {
      width: "45px"
    },
    onValueChange: function onValueChange(value) {
      return elementEditor.modifyElementAt(path, function (el) {
        return {
          item: "el.props.chartItems.props[" + itemIndex + "].basicConfig.padAngle",
          value: el.props.chartItems.props[itemIndex].basicConfig.padAngle = (0, _numericInputMinMaxSanitizer.numericInputMinMaxSanitizer)(value, MIN_PAD_ANGLE, MAX_PAD_ANGLE)
        };
      });
    },
    value: ((_chartItem$basicConfi4 = chartItem.basicConfig) == null ? void 0 : _chartItem$basicConfi4.padAngle) || defaultPadAngle
  }))), /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
    label: translate("PieChartBasicConfigSelector.basicConfig.borderRadius.label", "Border radius"),
    style: {
      marginTop: "10px"
    }
  }, /*#__PURE__*/_react["default"].createElement(_core.Tooltip, {
    content: translate("PieChartBasicConfigSelector.basicConfig.borderRadius.tooltip", "Radius of border to make chart items round"),
    position: _core.Position.TOP
  }, /*#__PURE__*/_react["default"].createElement(_core.NumericInput, {
    "data-testid": "PieChartBasicConfigSelector.basicConfig.borderRadius.input",
    min: MIN_BORDER_RADIUS,
    max: MAX_BORDER_RADIUS,
    style: {
      width: "45px"
    },
    onValueChange: function onValueChange(value) {
      return elementEditor.modifyElementAt(path, function (el) {
        return {
          item: "el.props.chartItems.props[" + itemIndex + "].basicConfig.borderRadius",
          value: el.props.chartItems.props[itemIndex].basicConfig.borderRadius = (0, _numericInputMinMaxSanitizer.numericInputMinMaxSanitizer)(value, MIN_BORDER_RADIUS, MAX_BORDER_RADIUS)
        };
      });
    },
    value: ((_chartItem$basicConfi5 = chartItem.basicConfig) == null ? void 0 : _chartItem$basicConfi5.borderRadius) || defaultBorderRadius
  }))));
};